module.exports = __webpack_public_path__ + "static/img/潘芬.f1173f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/teacher/潘芬.jpg
// module id = 4N1b
// module chunks = 140